import styled from 'styled-components';
import { SummaryPlayEventsWrapper, IconWrapper, SummaryPlayEvent } from './play/SummaryPlayEvents.style';
import { PlayVideoWrapper } from './play/playResults/PlayVideo.style';

import { PlayStatusWrapper, BaseRunnerText } from './play/utils/PlayStatus.style';
import { PlayScoresWrapper } from './play/PlayScores.style';

import { TitleWrapper, GameTimeWrapper } from '../FirstPitch/FirstPitch.style';

const playPosition = 55;

export const PlaySegDiv = styled.div.attrs(({ dataType }) => ({
    'data-seg-type': dataType
}))`
  margin-bottom: 24px;
  ${SummaryPlayEventsWrapper} {
    min-height: 52px;
  }
`;

export const LiveFeedPlayWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  ${SummaryPlayEventsWrapper} {
    margin-left: -${playPosition}px;
  }
  ${PlayVideoWrapper} {
    margin-left: 0px;
  }

  ${PlayScoresWrapper} {
    padding-left: 0;
  }

  ${BaseRunnerText} {
     margin-left: 17px;
  }

  ${TitleWrapper} {
    line-height: 18px;
  }

  ${GameTimeWrapper} {
    line-height: 20px;
  }

  div[data-seg-type="offensive_substitution"] + div[data-seg-type="offensive_substitution"] {
    margin-top: -16px;
    ${SummaryPlayEventsWrapper} {
      min-height: initial;
    }
    ${IconWrapper} {
      display: none;
    }
    ${SummaryPlayEvent} {
      display: none;
    }
  }

  div[data-seg-type="defensive_substitution"] + div[data-seg-type="defensive_substitution"] {
    margin-top: -16px;
    ${SummaryPlayEventsWrapper} {
      min-height: initial;
    }
    ${IconWrapper} {
      display: none;
    }
    ${SummaryPlayEvent} {
      display: none;
    }
  }

  div[data-seg-type="defensive_switch"] + div[data-seg-type="defensive_switch"] {
    margin-top: -16px;
    ${SummaryPlayEventsWrapper} {
      min-height: initial;
    }
    ${IconWrapper} {
      display: none;
    }
    ${SummaryPlayEvent} {
      display: none;
    }
  }

  ${PlayStatusWrapper} {
    margin-left: -45px;
    width: 100%;
    svg {
      background-color: var(--gameday-background-color);
      padding: 2px 0px;
    }
  }
`;
